// Equal height rows for comparision section
function syncComparisonRows() {

    const labels = document.querySelectorAll('.labels p');
    const columns = document.querySelectorAll('.col');

    // Reset heights first
    labels.forEach(label => {
        label.style.height = 'auto';
    });

    columns.forEach(col => {
        col.querySelectorAll('p').forEach(item => {
            item.style.height = 'auto';
        });
    });

    // Match heights row by row
    labels.forEach((label, index) => {

        let maxHeight = label.offsetHeight;

        columns.forEach(col => {
            const item = col.querySelectorAll('p')[index];

            if (item) {
                maxHeight = Math.max(maxHeight, item.offsetHeight);
            }
        });

        label.style.height = `${maxHeight}px`;

        columns.forEach(col => {
            const item = col.querySelectorAll('p')[index];

            if (item) {
                item.style.height = `${maxHeight}px`;
            }
        });

    });

}

window.addEventListener('load', syncComparisonRows);
window.addEventListener('resize', syncComparisonRows);


// custom class
document.querySelectorAll('.comparison-main').forEach(main => {

    const otherCols = main.querySelector('.other-cols');

    if (otherCols) {

        const totalCols = otherCols.querySelectorAll('.col').length;

        // Remove old classes first
        main.classList.remove(
            'column-1',
            'column-2',
            'column-3',
            'column-4'
        );

        // Add dynamic class
        if (totalCols > 0 && totalCols <= 4) {
            main.classList.add(`column-${totalCols}`);
        }
    }
});
